// app/javascript/controllers/inhalt_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inhaltstypSelect"]
  static values = { reiseId: Number }
  connect() {
    console.log("InhaltFormController connected")
  }

  toggleFields(event) {
    const inhaltstypId = event.target.value;
    const url = `/reisen/${this.reiseIdValue}/inhalte/conditional_fields?inhaltstyp_id=${inhaltstypId}`;
    const turboFrame = document.getElementById("conditional_inhalt_fields");
    turboFrame.src = url; // Löst das Laden des Turbo Frames aus
  }
}
